import { z } from 'zod';
import { oneOf, pageNum, pageSize, str } from '../../navigation/searchParams';

/** The Users table's sortable columns, as the table names them. */
export const USERS_SORT_COLUMNS = ['user', 'role', 'status', 'lastLogin'] as const;
export type UsersSortColumn = (typeof USERS_SORT_COLUMNS)[number];

/** The Users table's search, filters, paging and sort, and the user dialogs. */
export const usersSearch = z.object({
  q: str,
  role: oneOf(['viewer', 'operator', 'admin']),
  status: oneOf(['active', 'inactive', 'invite_pending']),
  page: pageNum,
  size: pageSize,
  sort: oneOf(USERS_SORT_COLUMNS),
  dir: oneOf(['asc', 'desc']),
  modal: oneOf(['create-user', 'user']),
  id: str,
  mtab: str,
});
